import { ErrorMessage } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { getCurrentMapDimensionIds } from "domains/createMapDetail/selectors";

export const DimensionLimitWarning = () => {
  const translate = useTranslate();
  const currentMapDimensionIds = useSelector(getCurrentMapDimensionIds);

  return currentMapDimensionIds.length <= 8 ? null : (
    <ErrorMessage isActive isWarning>
      {translate("app.topic.key_issue_soft_limit_warning_message")}
    </ErrorMessage>
  );
};
